import React from 'react'
import {Formik} from 'formik'
import {forgotPassword,getUser, login, verifyCode} from '../actions/auth'
import {connect} from 'react-redux'
import {withRouter, Link} from 'react-router-dom'
import { CSSTransition } from "react-transition-group"

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            formState: 'INITIAL',
            email:""
        }

    }

    render(){
        let url = window.location.origin
        
        let {
            dispatch
        } = this.props

        let {
            formState,
            isEmailSubmitted,
            isCodeSubmitted
        } = this.state

        let email="super@excelym.com"
        let password="Qazwsx123"

        let data={
            email:email,
            password:password
        }
        const NotificationMessage = {
            INITIAL: {
                message: "We will send a reset code to this email",
                alertClass: "alert-primary"
            },
            SUCCESS: {
                message: "The password reset code has been sent to your email, please check your email inbox or spam folder",
                alertClass: "alert-success"
            },
            ERROR: {
                message: "There was an error in sending the password reset code",
                alertClass: "alert-danger"
            }
        }

        return (
            <div>
                <CSSTransition
                    in={true}
                    appear={true}
                    timeout={5000}
                    classNames="fade"
                >
                <div className="forgot-center-wrapper">
                
                <div className="forgot-center-div">
                    <Formik
                        initialValues={{email: '',code:''}}
                        onSubmit={values => {
                            let category = 'forgotPassword'

                                dispatch(forgotPassword(values.email,category, url))
                                .then((response) => {
                                    console.log("response",response)
                                    if(response.ok){
                                        this.setState({
                                            formState: 'SUCCESS'
                                        })
                                    } else {
                                        this.setState({
                                            formState: 'ERROR'
                                        })
                                    }
                                })

                                this.setState({
                                    email: values.email
                                })
                            
                            
                        }}
                        
                        render={({
                            handleSubmit,
                            handleChange,
                            values
                        }) => (
                            <div className="login-view-wrapper">
                                    
                                <form
                                    onSubmit={handleSubmit}
                                    className="container"
                                >
                                    <div className='form-group'>
                                    <CSSTransition
                                            in={true}
                                            timeout={500}
                                            classNames="fade" 
                                    >
                                        <div className={`col s12 waves-effect pulse alert ${NotificationMessage[formState].alertClass}`}>
                                            <span>{NotificationMessage[formState].message}</span>
                                        </div>
                                    </CSSTransition>
                                    </div>
                                    <div className='form-group'>
                                            <input 
                                                className='form-control' 
                                                type='email' 
                                                name='email' 
                                                id='forgotemail' 
                                                onChange={handleChange} 
                                                value={values.email}
                                                placeholder="Email"
                                            />

                                    </div>
                                    <center>
                                        <div className='form-group mt-3'>
                                                <button 
                                                    type='submit' 
                                                    name='btn_login' 
                                                    className='btn' 
                                                    onClick={(e)=>{
                                                        // console.log("this.dispatch",this.props)
                                                    }}
                                                >
                                                    Send Reset Link
                                                </button>
                                          
                                        </div>
                                        <div className='form-group mt-3'>
                                            <Link to="/">Back to Login Page</Link>
                                        </div>
                                    </center>
                                </form>
                            </div>
                        )}
                    />
                </div>
            </div></CSSTransition>
        </div>//End of entire wrapping Div
        )
    }
}

function mapStateToProps(){
    return {}
}

export default withRouter(connect(mapStateToProps)(ForgotPassword))


// WEBPACK FOOTER //
// ./src/components/forgotPassword.js